import React, { useState } from 'react'
import { Printer } from '../../media/icons'
import { StyledButton } from './styled'
import { Modal } from '../Modal'
import ViewerPDF from '../ViewerPDF'
import { useMutation } from 'components/graphql'
import Button from 'components/Button'
import { Form, Radio } from 'components/forms'
import { DateIntervalForm } from 'components/shared/DateIntervalForm'
import moment from 'moment'
import Divider from '../Divider'
import { useTranslation } from 'react-i18next'

const Print = (props) => {
	const { width, tableTitles, mutationPdf, mutationPDFWithTimePeriod, dataCurrentJson, urlPath, urlPathWithTimePeriod, withTimePeriod = false, withMaxDate = true } = props
	const [openModal, setOpenModal] = useState(false)
	const [openDateModal, setOpenDateModal] = useState(false)
	const [pdfUrl, setPdfUrl] = useState('')
	const [variantPrint, setVariantPrint] = useState({
		allProduct: true,
		current_product: false
	})
	const [t, i18n] = useTranslation()
	const initialPeriod = {
		from: moment().utc().startOf('day').toISOString(),
		to: moment().utc().endOf('day').toISOString()
	}
	const handleSubmit = ({ period }) => {
		if(variantPrint.current_product) {
			handleGeneratePdf()
		}
		if(variantPrint.allProduct) {
			generatePdfFileWithTimePeriod({
				variables: {
					attributes: {
						to: period?.to,
						from: period?.from,
						type: [1, 2, 3],
						language: i18n.language,
						titles: tableTitles
					}
				}
			})
		}
		setOpenDateModal(false)
		setVariantPrint({ allProduct: true, current_product: false })
	}

	const [generatePdfFile] = useMutation(mutationPdf, {
		onCompleted: res => {
			const url = res?.[urlPath]?.url
			if(url) {
				setPdfUrl(url)
				setOpenModal((prev) => !prev)
			}
		}
	})

	const [generatePdfFileWithTimePeriod] = useMutation(mutationPDFWithTimePeriod, {
		onCompleted: res => {
			const url = res?.[urlPathWithTimePeriod]?.url
			if(url) {
				setPdfUrl(url)
				setOpenModal((prev) => !prev)
			}
		}
	})

	const handleGeneratePdf = () => {
		generatePdfFile({
			variables: {
				dataJson: dataCurrentJson,
				titles: tableTitles
			}
		})
	}
	return (<>
		<StyledButton type='button' width={width}><Printer onClick={withTimePeriod ? () => setOpenDateModal(true) : handleGeneratePdf} /></StyledButton>
		{openDateModal &&
			<Modal label={t('statistic_section.strings.separate_days')} width={500} unmount={() => setOpenDateModal(false)}>
				<Form initialValues={{ period: initialPeriod }} onSubmit={handleSubmit}>
					<DateIntervalForm disabled={variantPrint.current_product} maxDate={withMaxDate ? moment().utc() : null}/>
					<Divider visible width={35}/>
					<Radio noForm name='variantPrint' onChange={() => setVariantPrint({ allProduct: true, current_product: false })} checked={variantPrint.allProduct} label={t('common.strings.all_products')} />
					<Radio noForm name='variantPrint' onChange={() => setVariantPrint({ allProduct: false, current_product: true })} checked={variantPrint.current_product} label={t('common.strings.current_product')} />
					<Divider/>
					<Button type='submit' text={t('common.buttons.apply')} />
				</Form>
			</Modal>
		}
		{openModal &&
			<Modal unmount={() => setOpenModal(false)} fullScreen={true}>
				<ViewerPDF src={pdfUrl} style={{ height: '100%' }} />
			</Modal>
		}
	</>)
}


export default Print
